import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

import { ManagedUserGroupView } from "../../types";

const IdpGroupMappingTableDescriptionCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={group.description} />
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableDescriptionCell;
